<script setup>
import ContactHeading from "@/views/about/components/ContactHeading.vue";
import CsaDesc from "@/views/about/components/CsaDesc.vue";
import ContactForm from "@/views/about/components/ContactForm.vue";
import {getCurrentInstance, onMounted, reactive} from "vue";
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const contactPageData = reactive({});

onMounted(()=>{
  $axios.get($endpoint.LoadContact).then((resp_contact_data)=>{
    Object.assign(contactPageData, resp_contact_data.data);
  });
  console.log(contactPageData);
})
</script>

<template>
  <contact-heading v-if="contactPageData && contactPageData.hero" :hero="contactPageData?.hero"></contact-heading>
  <csa-desc v-if="contactPageData && contactPageData?.feebackSection" :about-infos="contactPageData.feebackSection?.aboutInfos"></csa-desc>
  <contact-form  v-if="contactPageData && contactPageData?.feebackSection"
                 :bg-image-url="contactPageData.feebackSection?.sectionImage?.url"
                 :social-link="contactPageData.feebackSection?.socialLinks"
                 :title="contactPageData.feebackSection?.title"
                 :subtitle="contactPageData.feebackSection?.subtitle"
  ></contact-form>
</template>

<style scoped>

</style>